import { useMemo } from 'react'
import { WatchQueryFetchPolicy } from '@apollo/client'

import { useLoggedInUser } from '../../../../../../../hooks/useLoggedInUser'
import { CustomerRole } from '../../../../../../../types/gql-global-types'
import { useSavingsAccountInterestRateQuery } from './graphql/SavingsAccountInterestRateQuery.generated'

interface UseGetInterestRateProps {
  fetchPolicy?: WatchQueryFetchPolicy
}

export const useGetInterestRate = ({
  fetchPolicy = 'cache-first',
}: UseGetInterestRateProps = {}) => {
  const { userRole } = useLoggedInUser()

  const {
    loading: isLoadingInterestRate,
    error: interestRateError,
    data,
  } = useSavingsAccountInterestRateQuery({
    fetchPolicy,
    errorPolicy: 'all',
    skip: userRole !== CustomerRole.ADMIN,
  })

  const interestRate = useMemo(() => {
    return data?.getEntity
  }, [data?.getEntity])

  return {
    isLoadingInterestRate,
    interestRateError,
    interestRate,
  }
}
